import React from 'react';
import { ViewButton, EditButton } from '../Common/DataTable/tableActionButtons';

const createTableColumns = (openViewModal, openEditModal) => [
  {
    title: 'Name',
    name: 'name',
  },
  {
    title: 'Type Field',
    name: 'typeField',
    width: 100,
  },
  {
    title: 'Required',
    name: 'required',
    width: 100,
    getCellValue: (row) => (row.required ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value === 'yes' ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-warning font-size-12">NO</span>
      ),
  },
  {
    title: 'Show In FormLead',
    name: 'showInFormLead',
    width: 100,
    getCellValue: (row) => (row.showInFormLead ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-warning font-size-12">NO</span>
      ),
  },
  {
    title: 'Personal Attribute',
    name: 'personalAttribute',
    width: 100,
    getCellValue: (row) => (row.personalAttribute ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-warning font-size-12">NO</span>
      ),
  },
  /*{
      title: 'List Values',
      name: 'listValues',
      sort: true,
      formatterComponent: ({ value }) => {
        if(value.length === 0) return '';
        return value.map(field => field.title).join(', '); 
      },
    },*/
  {
    title: 'Action',
    name: 'action',
    width: 120,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
